// // // // import { useEffect } from "react";
// // // // import axios from "axios";
// // // // import Config from "../../../config";

// // // // export const useDepartmentHandlers = ({
// // // //   departments,
// // // //   employees,
// // // //   filters,
// // // //   searchTerm,
// // // //   page,
// // // //   setPage, // Add setPage to props
// // // //   selectedDepartments,
// // // //   setSelectedDepartments,
// // // //   onEmployeesChange,
// // // //   setError,
// // // //   rowsPerPage = 3,
// // // // }) => {


// // // //   const handleAddDepartments = async () => {
// // // //   if (selectedDepartments.length === 0) return;

// // // //   let accumulatedEmployees = [...employees];

// // // //   for (const deptName of selectedDepartments) {
// // // //     const deptData = departments.find((d) => d.name === deptName);

// // // //     if (!deptData) continue;

// // // //     const departmentId =
// // // //       deptData.guid ||
// // // //       deptData.GUID ||
// // // //       deptData.department_guid ||
// // // //       deptData.DepartmentUid;

// // // //     if (!departmentId) {
// // // //       console.warn("Missing department ID:", deptData);
// // // //       continue;
// // // //     }

// // // //     try {
// // // //       const res = await axios.get(`/coordinators/employees-list/`, {
// // // //         params: {
// // // //           department_id: departmentId,
// // // //           page,
// // // //           page_size: rowsPerPage,
// // // //         },
// // // //       });

// // // //       const newEmployees = res.data.data
// // // //         .filter(emp => emp.DepartmentId === departmentId)
// // // //         .map(emp => ({
// // // //           id: emp.EmployeeId || emp.GUID,
// // // //           employee1_guid: emp.GUID,
// // // //           employee_guid: departmentId,
// // // //           employeeName: emp.EmployeeName,
// // // //           departmentId: emp.DepartmentId,
// // // //           departmentName: emp.DepartmentName || deptData.name,
// // // //           status: emp.Status || "Scheduled",
// // // //           isActive: true,
// // // //         }));



// // // //       const existingIds = accumulatedEmployees.map(e => e.id);

// // // //       accumulatedEmployees = [
// // // //         ...accumulatedEmployees,
// // // //         ...newEmployees.filter(e => !existingIds.includes(e.id)),
// // // //       ];

// // // //     } catch (error) {
// // // //       console.error(error);
// // // //       setError(`Error fetching employees for ${deptName}`);
// // // //     }
// // // //   }

// // // //   onEmployeesChange?.(accumulatedEmployees);
// // // //   setSelectedDepartments([]);
// // // // };

// // // //   const handleDelete = (id) => {
// // // //     const updated = employees.map((emp) =>
// // // //       emp.id === id ? { ...emp, isActive: false } : emp
// // // //     );
// // // //     onEmployeesChange?.(updated);
// // // //   };

// // // //   const handleUndo = (id) => {
// // // //     const updated = employees.map((emp) =>
// // // //       emp.id === id ? { ...emp, isActive: true } : emp
// // // //     );
// // // //     onEmployeesChange?.(updated);
// // // //   };

// // // //   const filteredEmployees = employees.filter((emp) => {
// // // //     const matchesSearch =
// // // //       emp.employeeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
// // // //       emp.departmentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
// // // //       emp.status.toLowerCase().includes(searchTerm.toLowerCase());

// // // //     const matchesDepartment =
// // // //       filters.departments.length === 0 ||
// // // //       filters.departments.includes(emp.departmentName);

// // // //     const matchesStatus =
// // // //       filters.status.length === 0 || filters.status.includes(emp.status);

// // // //     return matchesSearch && matchesDepartment && matchesStatus;
// // // //   });

// // // //   const activeFilteredEmployees = filteredEmployees;

// // // //   const totalPages = Math.ceil(activeFilteredEmployees.length / rowsPerPage);
// // // //   // const totalPages = Math.ceil(res.data.count / rowsPerPage);
// // // //   const currentRows = activeFilteredEmployees.slice((page - 1) * rowsPerPage, page * rowsPerPage);

// // // //   const handlePageChange = (newPage) => {
// // // //     if (newPage >= 1 && newPage <= totalPages) {
// // // //       setPage(newPage);
// // // //     }
// // // //   };

// // // //   const renderPageNumbers = () => {
// // // //     const pages = [];
// // // //     if (totalPages <= 5) {
// // // //       for (let i = 1; i <= totalPages; i++) pages.push(i);
// // // //     } else {
// // // //       if (page <= 3) pages.push(1, 2, 3, "...", totalPages);
// // // //       else if (page >= totalPages - 2) pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
// // // //       else pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
// // // //     }
// // // //     return pages;
// // // //   };

// // // //   return {
// // // //     handleAddDepartments,
// // // //     handleDelete,
// // // //     handleUndo,
// // // //     filteredEmployees,
// // // //     totalPages,
// // // //     currentRows,
// // // //     handlePageChange,
// // // //     renderPageNumbers,
// // // //   };
// // // // };








// // // import { useEffect } from "react";
// // // import axios from "axios";

// // // export const useDepartmentHandlers = ({
// // //   departments,
// // //   employees,
// // //   filters,
// // //   searchTerm,
// // //   page,
// // //   setPage,
// // //   selectedDepartments,
// // //   setSelectedDepartments,
// // //   onEmployeesChange,
// // //   setError,
// // //   rowsPerPage = 10,
// // // }) => {

// // // // ✅ ADD DEPARTMENTS (FIXED)
// // // const handleAddDepartments = async () => {
// // //   if (selectedDepartments.length === 0) return;

// // //   let accumulatedEmployees = [...employees];

// // //   for (const deptName of selectedDepartments) {
// // //     const deptData = departments.find((d) => d.name === deptName);
// // //     if (!deptData) continue;

// // //     const departmentId =
// // //       deptData.guid ||
// // //       deptData.GUID ||
// // //       deptData.department_guid ||
// // //       deptData.DepartmentUid;

// // //     if (!departmentId) {
// // //       console.warn("Missing department ID:", deptData);
// // //       continue;
// // //     }

// // //       try {
// // //         const res = await axios.get(`/coordinators/employees-list/`, {
// // //           params: {
// // //             department_id: departmentId,
// // //             page,
// // //             page_size: rowsPerPage,
// // //           },
// // //         });

// // //         const newEmployees = res.data.data
// // //           .filter((emp) => emp.DepartmentId === departmentId)
// // //           .map((emp) => ({
// // //             id: emp.EmployeeId || emp.GUID,
// // //             employee_guid: emp.GUID,
// // //             employeeName: emp.EmployeeName || "",
// // //             departmentId: emp.DepartmentId,
// // //             departmentName: emp.DepartmentName || deptName,
// // //             status: emp.Status || "Scheduled",
// // //             isActive: true,
// // //           }));

// // //         const existingIds = accumulatedEmployees.map((e) => e.id);

// // //         accumulatedEmployees = [
// // //           ...accumulatedEmployees,
// // //           ...newEmployees.filter((e) => !existingIds.includes(e.id)),
// // //         ];
// // //       } catch (error) {
// // //         console.error(error);
// // //         setError(`Error fetching employees for ${deptName}`);
// // //       }
// // //     }

// // //     onEmployeesChange?.(accumulatedEmployees);
// // //     setSelectedDepartments([]);
// // //   };

// // //   // ✅ SEARCH API CALL (FIXED + DEBOUNCED)
// // //   useEffect(() => {
// // //     if (!searchTerm) return;

// // //     const fetchSearchResults = async () => {
// // //       try {
// // //         const res = await axios.get(`/coordinators/employees-list/`, {
// // //           params: {
// // //             search: searchTerm,
// // //             page,
// // //             page_size: rowsPerPage,
// // //           },
// // //         });

// // //         const mapped = res.data.data.map((emp) => ({
// // //           id: emp.EmployeeId || emp.GUID,
// // //           employee_guid: emp.GUID,
// // //           employeeName: emp.EmployeeName || "",
// // //           departmentId: emp.DepartmentId,
// // //           departmentName: emp.DepartmentName || "N/A",
// // //           status: emp.Status || "Scheduled",
// // //           isActive: true,
// // //         }));

// // //         onEmployeesChange?.(mapped);
// // //       } catch (err) {
// // //         console.error(err);
// // //         setError("Search failed");
// // //       }
// // //     };

// // //     const debounce = setTimeout(fetchSearchResults, 400);
// // //     return () => clearTimeout(debounce);

// // //   }, [searchTerm, page, rowsPerPage]);

// // //   // ✅ DELETE
// // //   const handleDelete = (id) => {
// // //     const updated = employees.map((emp) =>
// // //       emp.id === id ? { ...emp, isActive: false } : emp
// // //     );
// // //     onEmployeesChange?.(updated);
// // //   };

// // //   // ✅ UNDO
// // //   const handleUndo = (id) => {
// // //     const updated = employees.map((emp) =>
// // //       emp.id === id ? { ...emp, isActive: true } : emp
// // //     );
// // //     onEmployeesChange?.(updated);
// // //   };

// // //   // ✅ SAFE FILTERING (NO CRASH)
// // //   const filteredEmployees = employees.filter((emp) => {
// // //     const term = (searchTerm || "").toLowerCase();

// // //     const matchesSearch =
// // //       (emp.employeeName || "").toLowerCase().includes(term) ||
// // //       (emp.departmentName || "").toLowerCase().includes(term) ||
// // //       (emp.status || "").toLowerCase().includes(term);

// // //     const matchesDepartment =
// // //       filters.departments.length === 0 ||
// // //       filters.departments.includes(emp.departmentName);

// // //     const matchesStatus =
// // //       filters.status.length === 0 ||
// // //       filters.status.includes(emp.status);

// // //     return matchesSearch && matchesDepartment && matchesStatus;
// // //   });

// // //   // ✅ PAGINATION (FRONTEND)
// // //   const totalPages = Math.ceil(filteredEmployees.length / rowsPerPage);

// // //   const currentRows = filteredEmployees.slice(
// // //     (page - 1) * rowsPerPage,
// // //     page * rowsPerPage
// // //   );

// // //   const handlePageChange = (newPage) => {
// // //     if (newPage >= 1 && newPage <= totalPages) {
// // //       setPage(newPage);
// // //     }
// // //   };

// // //   const renderPageNumbers = () => {
// // //     const pages = [];

// // //     if (totalPages <= 5) {
// // //       for (let i = 1; i <= totalPages; i++) pages.push(i);
// // //     } else {
// // //       if (page <= 3) pages.push(1, 2, 3, "...", totalPages);
// // //       else if (page >= totalPages - 2)
// // //         pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
// // //       else
// // //         pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
// // //     }

// // //     return pages;
// // //   };

// // //   return {
// // //     handleAddDepartments,
// // //     handleDelete,
// // //     handleUndo,
// // //     filteredEmployees,
// // //     totalPages,
// // //     currentRows,
// // //     handlePageChange,
// // //     renderPageNumbers,
// // //   };
// // // };




// // import { useEffect } from "react";
// // import axios from "axios";

// // export const useDepartmentHandlers = ({
// //   departments,
// //   employees,
// //   filters,
// //   searchTerm,
// //   page,
// //   setPage,
// //   selectedDepartments,
// //   setSelectedDepartments,
// //   onEmployeesChange,
// //   setError,
// //   rowsPerPage = 10,
// // }) => {

// //   // ✅ COMMON FUNCTION → FETCH EMPLOYEES (used for both add + search)
// //   const fetchEmployees = async ({ search = "" } = {}) => {
// //     if (selectedDepartments.length === 0) return;

// //     // let accumulatedEmployees = [];
// //     let accumulatedEmployees = [...employees];

// //     for (const deptName of selectedDepartments) {
// //       const deptData = departments.find((d) => d.name === deptName);
// //       if (!deptData) continue;

// //       const departmentId =
// //         deptData.guid ||
// //         deptData.GUID ||
// //         deptData.department_guid ||
// //         deptData.DepartmentUid;

// //       if (!departmentId) {
// //         console.warn("Missing department ID:", deptData);
// //         continue;
// //       }

// //       try {
// //         const res = await axios.get(`/coordinators/employees-list/`, {
// //           params: {
// //             department_id: departmentId,
// //             search,
// //             page,
// //             page_size: rowsPerPage,
// //           },
// //         });

// //         const mapped = res.data.data
// //           // ✅ ADD THIS FILTER HERE (CORRECT PLACE)
// //           .filter((emp) => emp.DepartmentId === departmentId)
// //           .map((emp) => ({
// //             id: emp.EmployeeId || emp.GUID,
// //             employee_guid: emp.GUID,
// //             employeeName: emp.EmployeeName || "",
// //             departmentId: emp.DepartmentId,
// //             departmentName: emp.DepartmentName || deptName,
// //             status: emp.Status || "Scheduled",
// //             isActive: true,
// //           }));

// //         // accumulatedEmployees.push(...mapped);
// //         const existingIds = accumulatedEmployees.map(e => e.id);

// //         accumulatedEmployees = [
// //           ...accumulatedEmployees,
// //           ...mapped.filter(e => !existingIds.includes(e.id)),
// //         ];

// //       } catch (error) {
// //         console.error(error);
// //         setError(`Error fetching employees for ${deptName}`);
// //       }
// //     }

// //     onEmployeesChange?.(accumulatedEmployees);
// //   };

// //   // ✅ ADD DEPARTMENTS
// //   const handleAddDepartments = async () => {
// //     if (selectedDepartments.length === 0) return;

// //     await fetchEmployees(); // no search
// //     setSelectedDepartments([]);
// //   };

// //   // ✅ SEARCH (FIXED: uses department_id + search)
// //   useEffect(() => {
// //     if (!searchTerm) return;
// //     if (selectedDepartments.length === 0) return;

// //     const debounce = setTimeout(() => {
// //       fetchEmployees({ search: searchTerm });
// //     }, 400);

// //     return () => clearTimeout(debounce);

// //   }, [searchTerm, page, rowsPerPage, selectedDepartments]);

// //   // ✅ DELETE
// //   const handleDelete = (id) => {
// //     const updated = employees.map((emp) =>
// //       emp.id === id ? { ...emp, isActive: false } : emp
// //     );
// //     onEmployeesChange?.(updated);
// //   };

// //   // ✅ UNDO
// //   const handleUndo = (id) => {
// //     const updated = employees.map((emp) =>
// //       emp.id === id ? { ...emp, isActive: true } : emp
// //     );
// //     onEmployeesChange?.(updated);
// //   };

// //   // ✅ FRONTEND FILTER (ONLY for dropdown filters, NOT search)
// //   const filteredEmployees = employees.filter((emp) => {
// //     const matchesDepartment =
// //       filters.departments.length === 0 ||
// //       filters.departments.includes(emp.departmentName);

// //     const matchesStatus =
// //       filters.status.length === 0 ||
// //       filters.status.includes(emp.status);

// //     return matchesDepartment && matchesStatus;
// //   });

// //   // ✅ PAGINATION (based on API-loaded data)
// //   const totalPages = Math.ceil(filteredEmployees.length / rowsPerPage);

// // const currentRows = filteredEmployees;

// //   const handlePageChange = (newPage) => {
// //     if (newPage >= 1 && newPage <= totalPages) {
// //       setPage(newPage);
// //     }
// //   };

// //   const renderPageNumbers = () => {
// //     const pages = [];

// //     if (totalPages <= 5) {
// //       for (let i = 1; i <= totalPages; i++) pages.push(i);
// //     } else {
// //       if (page <= 3) pages.push(1, 2, 3, "...", totalPages);
// //       else if (page >= totalPages - 2)
// //         pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
// //       else
// //         pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
// //     }

// //     return pages;
// //   };

// //   return {
// //     handleAddDepartments,
// //     handleDelete,
// //     handleUndo,
// //     filteredEmployees,
// //     totalPages,
// //     currentRows,
// //     handlePageChange,
// //     renderPageNumbers,
// //   };
// // };








// // import { useEffect, useState } from "react";
// // import axios from "axios";

// // export const useDepartmentHandlers = ({
// //   departments,
// //   employees,
// //   filters,
// //   searchTerm,
// //   page,
// //   setPage,
// //   selectedDepartments,
// //   setSelectedDepartments,
// //   onEmployeesChange,
// //   setError,
// //   rowsPerPage = 10,
// // }) => {

// //   const [totalCount, setTotalCount] = useState(0);

// //   // ✅ COMMON FETCH FUNCTION
// //   const fetchEmployees = async ({ search = "" } = {}) => {
// //     if (selectedDepartments.length === 0) return { accumulatedEmployees: [], totalCount: 0 };

// //     let accumulatedEmployees = [...employees];
// //     let total = 0;

// //     for (const deptName of selectedDepartments) {
// //       const deptData = departments.find((d) => d.name === deptName);
// //       if (!deptData) continue;

// //       const departmentId =
// //         deptData.guid ||
// //         deptData.GUID ||
// //         deptData.department_guid ||
// //         deptData.DepartmentUid;

// //       if (!departmentId) continue;

// //       try {
// //         const res = await axios.get(`/coordinators/employees-list/`, {
// //           params: {
// //             department_id: departmentId,
// //             search,
// //             page,
// //             page_size: rowsPerPage,
// //           },
// //         });

// //         total = res.data.count || 0;

// //         const mapped = res.data.data
// //           .filter((emp) => emp.DepartmentId === departmentId)
// //           .map((emp) => ({
// //             id: emp.EmployeeId || emp.GUID,
// //             employee_guid: emp.GUID,
// //             employeeName: emp.EmployeeName || "",
// //             departmentId: emp.DepartmentId,
// //             departmentName: emp.DepartmentName || deptName,
// //             status: emp.Status || "Scheduled",
// //             isActive: true,
// //           }));

// //         const existingIds = accumulatedEmployees.map((e) => e.id);

// //         accumulatedEmployees = [
// //           ...accumulatedEmployees,
// //           ...mapped.filter((e) => !existingIds.includes(e.id)),
// //         ];

// //       } catch (error) {
// //         console.error(error);
// //         setError(`Error fetching employees for ${deptName}`);
// //       }
// //     }

// //     return { accumulatedEmployees, totalCount: total };
// //   };

// //   // ✅ ADD DEPARTMENTS
// //   const handleAddDepartments = async () => {
// //     if (selectedDepartments.length === 0) return;

// //     const { accumulatedEmployees, totalCount } = await fetchEmployees();

// //     onEmployeesChange?.(accumulatedEmployees);
// //     setTotalCount(totalCount);
// //     setSelectedDepartments([]);
// //   };

// //   // ✅ SEARCH + PAGE CHANGE (API CALL)
// //   useEffect(() => {
// //     if (selectedDepartments.length === 0) return;

// //     const debounce = setTimeout(async () => {
// //       const { accumulatedEmployees, totalCount } =
// //         await fetchEmployees({ search: searchTerm });

// //       onEmployeesChange?.(accumulatedEmployees);
// //       setTotalCount(totalCount);
// //     }, 400);

// //     return () => clearTimeout(debounce);

// //   }, [searchTerm, page, rowsPerPage, selectedDepartments]);

// //   // ✅ DELETE
// //   const handleDelete = (id) => {
// //     const updated = employees.map((emp) =>
// //       emp.id === id ? { ...emp, isActive: false } : emp
// //     );
// //     onEmployeesChange?.(updated);
// //   };

// //   // ✅ UNDO
// //   const handleUndo = (id) => {
// //     const updated = employees.map((emp) =>
// //       emp.id === id ? { ...emp, isActive: true } : emp
// //     );
// //     onEmployeesChange?.(updated);
// //   };

// //   // ✅ FILTER (ONLY UI FILTERS, NOT SEARCH)
// //   const filteredEmployees = employees.filter((emp) => {
// //     const matchesDepartment =
// //       filters.departments.length === 0 ||
// //       filters.departments.includes(emp.departmentName);

// //     const matchesStatus =
// //       filters.status.length === 0 ||
// //       filters.status.includes(emp.status);

// //     return matchesDepartment && matchesStatus;
// //   });

// //   // ✅ SERVER SIDE PAGINATION
// //   const totalPages = Math.ceil(totalCount / rowsPerPage);

// //   const currentRows = filteredEmployees; // 👈 IMPORTANT (NO slice)

// //   const handlePageChange = (newPage) => {
// //     if (newPage >= 1 && newPage <= totalPages) {
// //       setPage(newPage);
// //     }
// //   };

// //   const renderPageNumbers = () => {
// //     const pages = [];

// //     if (totalPages <= 5) {
// //       for (let i = 1; i <= totalPages; i++) pages.push(i);
// //     } else {
// //       if (page <= 3) pages.push(1, 2, 3, "...", totalPages);
// //       else if (page >= totalPages - 2)
// //         pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
// //       else
// //         pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
// //     }

// //     return pages;
// //   };

// //   return {
// //     handleAddDepartments,
// //     handleDelete,
// //     handleUndo,
// //     filteredEmployees,
// //     totalPages,
// //     currentRows,
// //     handlePageChange,
// //     renderPageNumbers,
// //   };
// // };








// // import { useEffect, useState, useCallback, useRef } from "react";
// // import axios from "axios";

// // export const useDepartmentHandlers = ({
// //   departments,
// //   employees,
// //   filters,
// //   searchTerm,
// //   page,
// //   setPage,
// //   selectedDepartments,
// //   setSelectedDepartments,
// //   onEmployeesChange,
// //   setError,
// //   rowsPerPage = 10,
// // }) => {
// //   const [totalCount, setTotalCount] = useState(0);
// //   const [addedDepartments, setAddedDepartments] = useState([]);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const abortRef = useRef(null);

// //   // ✅ SAFE MAPPER
// //   const mapEmployees = (data, deptName, departmentId) => {
// //     if (!Array.isArray(data)) return []; // ✅ FIX

// //     return data
// //       .filter((emp) => emp.DepartmentId === departmentId)
// //       .map((emp) => ({
// //         id: emp.EmployeeId || emp.GUID,
// //         employee_guid: emp.GUID,
// //         employeeName: emp.EmployeeName || "",
// //         departmentId: emp.DepartmentId,
// //         departmentName: emp.DepartmentName || deptName,
// //         status: emp.Status || "Scheduled",
// //         isActive: true,
// //       }));
// //   };

// //   // ✅ ADD DEPARTMENTS (APPEND DATA)
// //   const handleAddDepartments = async () => {
// //     if (selectedDepartments.length === 0) return;

// //     setIsLoading(true);

// //     let allEmployees = [...employees];
// //     let total = 0;
// //     let newAdded = [...addedDepartments];

// //     for (const deptName of selectedDepartments) {
// //       if (newAdded.includes(deptName)) continue;

// //       const deptData = departments.find((d) => d.name === deptName);
// //       if (!deptData) continue;

// //       const departmentId =
// //         deptData.guid ||
// //         deptData.GUID ||
// //         deptData.department_guid ||
// //         deptData.DepartmentUid;

// //       try {
// //         const res = await axios.get(`/coordinators/employees-list/`, {
// //           params: {
// //             department_id: departmentId,
// //             page: 1,
// //             page_size: rowsPerPage,
// //           },
// //         });

// //         const mapped = mapEmployees(res.data?.data, deptName, departmentId);

// //         const existingIds = new Set(allEmployees.map((e) => e.id));
// //         const unique = mapped.filter((e) => !existingIds.has(e.id));

// //         allEmployees = [...allEmployees, ...unique];

// //         total += res.data?.count || 0;
// //         newAdded.push(deptName);

// //       } catch (err) {
// //         console.error(err);
// //         setError?.("Error fetching departments");
// //       }
// //     }

// //     onEmployeesChange(allEmployees);
// //     setAddedDepartments(newAdded);
// //     setTotalCount(total);
// //     setSelectedDepartments([]);
// //     setPage(1);
// //     setIsLoading(false);
// //   };

// //   // ✅ FETCH (SEARCH + PAGINATION)
// //   const fetchData = useCallback(async () => {
// //     if (addedDepartments.length === 0) return;

// //     setIsLoading(true);

// //     if (abortRef.current) abortRef.current.abort();
// //     abortRef.current = new AbortController();

// //     let allEmployees = [];
// //     let total = 0;

// //     for (const deptName of addedDepartments) {
// //       const deptData = departments.find((d) => d.name === deptName);
// //       if (!deptData) continue;

// //       const departmentId =
// //         deptData.guid ||
// //         deptData.GUID ||
// //         deptData.department_guid ||
// //         deptData.DepartmentUid;

// //       try {
// //         const res = await axios.get(`/coordinators/employees-list/`, {
// //           params: {
// //             department_id: departmentId,
// //             search: searchTerm || undefined,
// //             page: page, // ✅ IMPORTANT
// //             page_size: rowsPerPage,
// //           },
// //           signal: abortRef.current.signal,
// //         });

// //         const mapped = mapEmployees(res.data?.data, deptName, departmentId);

// //         allEmployees = [...allEmployees, ...mapped];
// //         total += res.data?.count || 0;

// //       } catch (err) {
// //         if (err.name !== "CanceledError") {
// //           console.error(err);
// //           setError?.("Fetch error");
// //         }
// //       }
// //     }

// //     onEmployeesChange(allEmployees);
// //     setTotalCount(total);
// //     setIsLoading(false);

// //   }, [addedDepartments, departments, searchTerm, page]);

// //   // ✅ TRIGGER API ON SEARCH + PAGE
// //   useEffect(() => {
// //     if (addedDepartments.length === 0) return;

// //     const delay = setTimeout(fetchData, 400);
// //     return () => clearTimeout(delay);

// //   }, [searchTerm, page]);

// //   // ✅ DELETE
// //   const handleDelete = (id) => {
// //     onEmployeesChange(
// //       employees.map((e) =>
// //         e.id === id ? { ...e, isActive: false } : e
// //       )
// //     );
// //   };

// //   // ✅ UNDO
// //   const handleUndo = (id) => {
// //     onEmployeesChange(
// //       employees.map((e) =>
// //         e.id === id ? { ...e, isActive: true } : e
// //       )
// //     );
// //   };

// //   // ✅ FILTERS (ONLY UI)
// //   const filteredEmployees = employees.filter((emp) => {
// //     const deptOk =
// //       filters.departments.length === 0 ||
// //       filters.departments.includes(emp.departmentName);

// //     const statusOk =
// //       filters.status.length === 0 ||
// //       filters.status.includes(emp.status);

// //     return deptOk && statusOk;
// //   });

// //   // ✅ API BASED PAGINATION
// //   const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));

// //   const handlePageChange = (newPage) => {
// //     if (newPage >= 1 && newPage <= totalPages) {
// //       setPage(newPage); // ✅ triggers API
// //     }
// //   };

// //   return {
// //     handleAddDepartments,
// //     handleDelete,
// //     handleUndo,
// //     filteredEmployees,
// //     currentRows: filteredEmployees,
// //     totalPages,
// //     handlePageChange,
// //     isLoading,
// //   };
// // };


// // import { useEffect, useState, useCallback, useRef } from "react";
// // import axios from "axios";
// // import React from "react";

// // export const useDepartmentHandlers = ({
// //   departments,
// //   employees,
// //   filters,
// //   searchTerm,
// //   page,
// //   setPage,
// //   selectedDepartments,
// //   setSelectedDepartments,
// //   onEmployeesChange,
// //   setError,
// //   rowsPerPage = 10,
// // }) => {
// //   const [addedDepartments, setAddedDepartments] = useState([]);
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [allEmployeesData, setAllEmployeesData] = useState([]);

// //   // Store department-specific data
// //   const [departmentCache, setDepartmentCache] = useState({});

// //   const abortRef = useRef(null);

// //   const mapEmployees = (data, deptName, departmentId) => {
// //   if (!Array.isArray(data)) return [];

// //   return data
// //     .filter((emp) => emp.DepartmentId === departmentId) // ✅ correct
// //     .map((emp) => ({
// //       id: emp.EmployeeId || emp.GUID,
// //       employee_guid: emp.GUID,
// //       employeeName: emp.EmployeeName || "",
// //       departmentId: emp.DepartmentId,
// //       departmentName: emp.DepartmentName || deptName,
// //       status: emp.Status || "Scheduled",
// //       isActive: true,
// //     }));
// // };

// //   // Fetch single department data
// //   const fetchDepartmentData = async (deptName, departmentId, search, pageNum) => {
// //     try {
// //       const res = await axios.get(`/coordinators/employees-list/`, {
// //         params: {
// //           department_id: departmentId,
// //           search: search || undefined,
// //           page: pageNum,
// //           page_size: rowsPerPage,
// //         },
// //       });

// //       return {
// //         employees: mapEmployees(res.data?.data, deptName, departmentId),
// //         count: res.data?.count || 0,
// //         totalPages: res.data?.totalPages || 1,
// //         page: res.data?.page || 1,
// //         pageSize: res.data?.pageSize || rowsPerPage,
// //         departmentName: deptName,
// //         departmentId: departmentId
// //       };
// //     } catch (err) {
// //       console.error(`Error fetching ${deptName}:`, err);
// //       setError?.("Error fetching department data");
// //       return {
// //         employees: [],
// //         count: 0,
// //         totalPages: 1,
// //         page: 1,
// //         pageSize: rowsPerPage,
// //         departmentName: deptName,
// //         departmentId: departmentId
// //       };
// //     }
// //   };

// //   // ADD DEPARTMENTS - FIXED
// //   const handleAddDepartments = async () => {
// //     if (selectedDepartments.length === 0) return;

// //     setIsLoading(true);

// //     try {
// //       const newAdded = [...addedDepartments];
// //       const newDepartmentData = { ...departmentCache };

// //       // Fetch data for each selected department
// //       for (const deptName of selectedDepartments) {
// //         if (newAdded.includes(deptName)) continue;

// //         const deptData = departments.find((d) => d.name === deptName);
// //         if (!deptData) continue;

// //         const departmentId = deptData.guid ||
// //           deptData.GUID ||
// //           deptData.department_guid ||
// //           deptData.DepartmentUid;

// //         // Fetch first page of this department
// //         const departmentInfo = await fetchDepartmentData(deptName, departmentId, searchTerm, 1);

// //         // Store department data
// //         newDepartmentData[deptName] = {
// //           ...departmentInfo,
// //           currentPage: 1,
// //           allPages: { 1: departmentInfo.employees }
// //         };

// //         newAdded.push(deptName);
// //       }

// //       // Update state
// //       setDepartmentCache(newDepartmentData);
// //       setAddedDepartments(newAdded);
// //       setSelectedDepartments([]);

// //       // Combine all employees from all departments for page 1
// //       let allEmployees = [];
// //       Object.values(newDepartmentData).forEach(dept => {
// //         allEmployees = [...allEmployees, ...dept.employees];
// //       });

// //       setAllEmployeesData(allEmployees);
// //       onEmployeesChange(allEmployees);
// //       setPage(1);

// //     } catch (err) {
// //       console.error("Error adding departments:", err);
// //       setError?.("Error adding departments");
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   // Fetch specific page for all departments
// //   const fetchPageForAllDepartments = useCallback(async (targetPage) => {
// //     if (addedDepartments.length === 0) return;

// //     setIsLoading(true);

// //     try {
// //       const updatedCache = { ...departmentCache };
// //       let allEmployees = [];
// //       let totalCount = 0;
// //       let maxTotalPages = 1;

// //       // Fetch data for each department for the target page
// //       for (const deptName of addedDepartments) {
// //         const deptData = departments.find((d) => d.name === deptName);
// //         if (!deptData) continue;

// //         const departmentId = deptData.guid ||
// //           deptData.GUID ||
// //           deptData.department_guid ||
// //           deptData.DepartmentUid;

// //         // Check if we already have this page cached
// //         if (updatedCache[deptName]?.allPages?.[targetPage]) {
// //           const cachedData = updatedCache[deptName].allPages[targetPage];
// //           allEmployees = [...allEmployees, ...cachedData];
// //           totalCount += updatedCache[deptName].count;
// //           maxTotalPages = Math.max(maxTotalPages, updatedCache[deptName].totalPages);
// //         } else {
// //           // Fetch new page
// //           const departmentInfo = await fetchDepartmentData(deptName, departmentId, searchTerm, targetPage);

// //           // Update cache
// //           if (!updatedCache[deptName]) {
// //             updatedCache[deptName] = {
// //               ...departmentInfo,
// //               currentPage: targetPage,
// //               allPages: {}
// //             };
// //           }

// //           updatedCache[deptName].allPages[targetPage] = departmentInfo.employees;
// //           updatedCache[deptName].currentPage = targetPage;

// //           allEmployees = [...allEmployees, ...departmentInfo.employees];
// //           totalCount += departmentInfo.count;
// //           maxTotalPages = Math.max(maxTotalPages, departmentInfo.totalPages);
// //         }
// //       }

// //       // Update state
// //       setDepartmentCache(updatedCache);
// //       setAllEmployeesData(allEmployees);
// //       onEmployeesChange(allEmployees);

// //       return { totalCount, maxTotalPages };

// //     } catch (err) {
// //       console.error("Error fetching page:", err);
// //       setError?.("Error fetching data");
// //       return { totalCount: 0, maxTotalPages: 1 };
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   }, [addedDepartments, departments, searchTerm, departmentCache, onEmployeesChange, setError]);

// //   // Handle page change
// //   const handlePageChange = useCallback(async (newPage) => {
// //     if (newPage < 1) return;
// //     setPage(newPage);
// //     await fetchPageForAllDepartments(newPage);
// //   }, [fetchPageForAllDepartments, setPage]);

// //   // Handle search with debounce
// //   const searchTimeoutRef = useRef(null);

// //   useEffect(() => {
// //     if (addedDepartments.length === 0) return;

// //     // Clear previous timeout
// //     if (searchTimeoutRef.current) {
// //       clearTimeout(searchTimeoutRef.current);
// //     }

// //     // Debounce search
// //     searchTimeoutRef.current = setTimeout(async () => {
// //       setPage(1); // Reset to page 1 on search
// //       setIsLoading(true);

// //       try {
// //         const updatedCache = { ...departmentCache };
// //         let allEmployees = [];
// //         let totalCount = 0;
// //         let maxTotalPages = 1;

// //         // Fetch fresh data for all departments with search term
// //         for (const deptName of addedDepartments) {
// //           const deptData = departments.find((d) => d.name === deptName);
// //           if (!deptData) continue;

// //           const departmentId = deptData.guid ||
// //             deptData.GUID ||
// //             deptData.department_guid ||
// //             deptData.DepartmentUid;

// //           const departmentInfo = await fetchDepartmentData(deptName, departmentId, searchTerm, 1);

// //           // Update cache
// //           updatedCache[deptName] = {
// //             ...departmentInfo,
// //             currentPage: 1,
// //             allPages: { 1: departmentInfo.employees }
// //           };

// //           allEmployees = [...allEmployees, ...departmentInfo.employees];
// //           totalCount += departmentInfo.count;
// //           maxTotalPages = Math.max(maxTotalPages, departmentInfo.totalPages);
// //         }

// //         setDepartmentCache(updatedCache);
// //         setAllEmployeesData(allEmployees);
// //         onEmployeesChange(allEmployees);

// //       } catch (err) {
// //         console.error("Search error:", err);
// //       } finally {
// //         setIsLoading(false);
// //       }
// //     }, 500);

// //     return () => {
// //       if (searchTimeoutRef.current) {
// //         clearTimeout(searchTimeoutRef.current);
// //       }
// //     };
// //   }, [searchTerm, addedDepartments, departments]);

// //   // DELETE
// //   const handleDelete = (id) => {
// //     const updatedEmployees = allEmployeesData.map((e) =>
// //       e.id === id ? { ...e, isActive: false } : e
// //     );
// //     setAllEmployeesData(updatedEmployees);
// //     onEmployeesChange(updatedEmployees);
// //   };

// //   // UNDO
// //   const handleUndo = (id) => {
// //     const updatedEmployees = allEmployeesData.map((e) =>
// //       e.id === id ? { ...e, isActive: true } : e
// //     );
// //     setAllEmployeesData(updatedEmployees);
// //     onEmployeesChange(updatedEmployees);
// //   };

// //   // Calculate total pages (use max from all departments)
// //   const totalPages = React.useMemo(() => {
// //     let maxPages = 1;
// //     Object.values(departmentCache).forEach(dept => {
// //       maxPages = Math.max(maxPages, dept.totalPages);
// //     });
// //     return maxPages;
// //   }, [departmentCache]);

// //   // Calculate total count
// //   const totalCount = React.useMemo(() => {
// //     let total = 0;
// //     Object.values(departmentCache).forEach(dept => {
// //       total += dept.count;
// //     });
// //     return total;
// //   }, [departmentCache]);

// //   // APPLY UI FILTERS
// //   const filteredEmployees = allEmployeesData.filter((emp) => {
// //     const deptOk =
// //       filters.departments.length === 0 ||
// //       filters.departments.includes(emp.departmentName);

// //     const statusOk =
// //       filters.status.length === 0 ||
// //       filters.status.includes(emp.status);

// //     return deptOk && statusOk;
// //   });

// //   // Get current rows with pagination and filters
// //   const currentRows = filteredEmployees;

// //   // Render page numbers
// //   const renderPageNumbers = () => {
// //     const pages = [];
// //     const maxVisible = 5;

// //     if (totalPages <= maxVisible) {
// //       for (let i = 1; i <= totalPages; i++) pages.push(i);
// //     } else {
// //       if (page <= 3) {
// //         pages.push(1, 2, 3, 4, '...', totalPages);
// //       } else if (page >= totalPages - 2) {
// //         pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
// //       } else {
// //         pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
// //       }
// //     }
// //     return pages;
// //   };

// //   // Initial load when departments are added
// //   useEffect(() => {
// //     if (addedDepartments.length > 0 && page === 1 && allEmployeesData.length === 0) {
// //       fetchPageForAllDepartments(1);
// //     }
// //   }, [addedDepartments]);

// //   return {
// //     handleAddDepartments,
// //     handleDelete,
// //     handleUndo,
// //     filteredEmployees,
// //     currentRows,
// //     totalPages,
// //     totalCount,
// //     currentPage: page,
// //     handlePageChange,
// //     renderPageNumbers,
// //     isLoading
// //   };
// // };






// import { useEffect, useState, useCallback, useRef } from "react";
// import axios from "axios";
// import React from "react";

// export const useDepartmentHandlers = ({
//   departments,
//   filters,
//   searchTerm,
//   page,
//   setPage,
//   selectedDepartments,
//   setSelectedDepartments,
//   onEmployeesChange,
//   setError,
//   rowsPerPage = 10,
// }) => {
//   const [addedDepartments, setAddedDepartments] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [allEmployeesData, setAllEmployeesData] = useState([]);

//   const abortRef = useRef(null);
//   const searchTimeoutRef = useRef(null);

//   // ----------------------------
//   // MAP EMPLOYEES
//   // ----------------------------
//   const mapEmployees = (data, deptName, departmentId) => {
//     if (!Array.isArray(data)) return [];

//     return data
//       .filter((emp) => emp.DepartmentId === departmentId)
//       .map((emp) => ({
//         id: emp.EmployeeId || emp.GUID,
//         employee_guid: emp.GUID,
//         employeeName: emp.EmployeeName || "",
//         departmentId: emp.DepartmentId,
//         departmentName: emp.DepartmentName || deptName,
//         status: emp.Status || "Scheduled",
//         isActive: true,
//       }));
//   };

//   // ----------------------------
//   // FETCH ALL EMPLOYEES (NO PAGINATION)
//   // ----------------------------
//   const fetchDepartmentData = async (deptName, departmentId, search) => {
//     try {
//       const res = await axios.get(`/coordinators/employees-list/`, {
//         params: {
//           department_id: departmentId,
//           search: search || undefined,
//           page: 1,
//           page_size: 10, // large batch fetch
//         },
//       });

//       return mapEmployees(res.data?.data, deptName, departmentId);
//     } catch (err) {
//       console.error(err);
//       setError?.("Error fetching department data");
//       return [];
//     }
//   };

//   // ----------------------------
//   // BUILD GLOBAL LIST
//   // ----------------------------
//   const buildEmployeeList = async () => {
//     let all = [];

//     for (const deptName of addedDepartments) {
//       const deptData = departments.find((d) => d.name === deptName);
//       if (!deptData) continue;

//       const departmentId =
//         deptData.guid ||
//         deptData.GUID ||
//         deptData.department_guid ||
//         deptData.DepartmentUid;

//       const employees = await fetchDepartmentData(
//         deptName,
//         departmentId,
//         searchTerm
//       );

//       all = [...all, ...employees];
//     }

//     return all;
//   };

//   // ----------------------------
//   // ADD DEPARTMENTS
//   // ----------------------------
//   const handleAddDepartments = async () => {
//     if (!selectedDepartments.length) return;

//     setIsLoading(true);

//     try {
//       const newAdded = [...addedDepartments];

//       for (const dept of selectedDepartments) {
//         if (!newAdded.includes(dept)) newAdded.push(dept);
//       }

//       setAddedDepartments(newAdded);
//       setSelectedDepartments([]);

//       const allEmployees = await buildEmployeeList();

//       setAllEmployeesData(allEmployees);
//       onEmployeesChange(allEmployees);
//       setPage(1);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ----------------------------
//   // RELOAD DATA (SEARCH / REFRESH)
//   // ----------------------------
//   const reloadData = async () => {
//     setIsLoading(true);

//     const allEmployees = await buildEmployeeList();

//     setAllEmployeesData(allEmployees);
//     onEmployeesChange(allEmployees);

//     setIsLoading(false);
//   };

//   // ----------------------------
//   // SEARCH (DEBOUNCE)
//   // ----------------------------
//   useEffect(() => {
//     if (!addedDepartments.length) return;

//     if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

//     searchTimeoutRef.current = setTimeout(() => {
//       setPage(1);
//       reloadData();
//     }, 400);

//     return () => clearTimeout(searchTimeoutRef.current);
//   }, [searchTerm]);

//   // ----------------------------
//   // DELETE / UNDO
//   // ----------------------------
//   const handleDelete = (id) => {
//     const updated = allEmployeesData.map((e) =>
//       e.id === id ? { ...e, isActive: false } : e
//     );
//     setAllEmployeesData(updated);
//     onEmployeesChange(updated);
//   };

//   const handleUndo = (id) => {
//     const updated = allEmployeesData.map((e) =>
//       e.id === id ? { ...e, isActive: true } : e
//     );
//     setAllEmployeesData(updated);
//     onEmployeesChange(updated);
//   };

//   // ----------------------------
//   // FILTERS
//   // ----------------------------
//   const filteredEmployees = allEmployeesData.filter((emp) => {
//     const deptOk =
//       filters.departments.length === 0 ||
//       filters.departments.includes(emp.departmentName);

//     const statusOk =
//       filters.status.length === 0 ||
//       filters.status.includes(emp.status);

//     return deptOk && statusOk;
//   });

//   // ----------------------------
//   // PAGINATION (FIXED - CLIENT SIDE ONLY)
//   // ----------------------------
//   const totalPages = Math.ceil(filteredEmployees.length / rowsPerPage);

//   const currentRows = React.useMemo(() => {
//     const start = (page - 1) * rowsPerPage;
//     const end = start + rowsPerPage;
//     return filteredEmployees.slice(start, end);
//   }, [filteredEmployees, page, rowsPerPage]);

//   const handlePageChange = (newPage) => {
//     if (newPage < 1 || newPage > totalPages) return;
//     setPage(newPage);
//   };

//   // ----------------------------
//   // PAGE NUMBERS
//   // ----------------------------
//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisible = 5;

//     if (totalPages <= maxVisible) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       if (page <= 3) {
//         pages.push(1, 2, 3, 4, "...", totalPages);
//       } else if (page >= totalPages - 2) {
//         pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
//       } else {
//         pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
//       }
//     }

//     return pages;
//   };

//   return {
//     handleAddDepartments,
//     handleDelete,
//     handleUndo,
//     filteredEmployees,
//     currentRows,
//     totalPages,
//     currentPage: page,
//     handlePageChange,
//     renderPageNumbers,
//     isLoading,
//   };
// };


import { useEffect, useState, useRef } from "react";
import axios from "axios";
import React from "react";

export const useDepartmentHandlers = ({
  departments,
  filters,
  searchTerm,
  page,
  setPage,
  selectedDepartments,
  setSelectedDepartments,
  onEmployeesChange,
  setError,
  examid,
  rowsPerPage = 10,
}) => {
  const [addedDepartments, setAddedDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allEmployeesData, setAllEmployeesData] = useState([]);

  const searchTimeoutRef = useRef(null);

  // ----------------------------
  // MAP EMPLOYEES (IGNORE NULL)
  // ----------------------------
  const mapEmployees = (data) => {
    if (!Array.isArray(data)) return [];

    return data
      // .filter((emp) => emp.DepartmentId) // ✅ ignore null
      .map((emp) => ({
        id: emp.GUID,
        employee_guid: emp.GUID,
        employeeName: emp.EmployeeName || "",
        departmentId: emp.DepartmentId,
        departmentName: emp.DepartmentName || "Unknown",
        status: emp.Status || "Scheduled",
        assessmentStatus: emp.AssessmentStatus || "Available",
        isActive: (emp.AssessmentStatus || "Available") === "Available",
        isDeleted: false,
      }));
  };

  // ----------------------------
  // FETCH MULTIPLE DEPARTMENTS
  // ----------------------------
  const fetchEmployees = async (deptIds, search) => {
    try {
      const res = await axios.post(
        `/coordinators/employees-list/`,
        {}, // ✅ empty body
        {
          params: {
            department_ids: deptIds.join(","), // multiple IDs
            search: search,
            page: 1,
            page_size: 1000,
            exam_id: examid,
          },
        }
      );

      return mapEmployees(res.data?.data);
    } catch (err) {
      console.error(err);
      setError?.("Error fetching employees");
      return [];
    }
  };

  // ----------------------------
  // BUILD LIST (SINGLE API CALL)
  // ----------------------------
  const buildEmployeeList = async () => {
    const deptIds = addedDepartments
      .map((deptName) => {
        const dept = departments.find((d) => d.name === deptName);
        return (
          dept?.guid ||
          dept?.GUID ||
          dept?.department_guid ||
          dept?.DepartmentUid
        );
      })
      .filter(Boolean);

    if (!deptIds.length) return [];

    return await fetchEmployees(deptIds, "");
  };

  // ----------------------------
  // ADD DEPARTMENTS
  // ----------------------------
  const handleAddDepartments = async () => {
    if (!selectedDepartments.length) return;

    setIsLoading(true);

    try {
      const newAdded = [
        ...new Set([...addedDepartments, ...selectedDepartments]),
      ];

      setAddedDepartments(newAdded);
      setSelectedDepartments([]);

      const allEmployees = await fetchEmployees(
        newAdded
          .map((deptName) => {
            const dept = departments.find((d) => d.name === deptName);
            return (
              dept?.guid ||
              dept?.GUID ||
              dept?.department_guid ||
              dept?.DepartmentUid
            );
          })
          .filter(Boolean),
        ""
      );

      setAllEmployeesData(allEmployees);
      onEmployeesChange(allEmployees);
      setPage(1);
    } finally {
      setIsLoading(false);
    }
  };

  // ----------------------------
  // SEARCH (DEBOUNCE)
  // ----------------------------
  useEffect(() => {
    if (!addedDepartments.length) return;

    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

    searchTimeoutRef.current = setTimeout(async () => {
      setPage(1);
      setIsLoading(true);

      const allEmployees = await buildEmployeeList();

      setAllEmployeesData(allEmployees);
      onEmployeesChange(allEmployees);

      setIsLoading(false);
    }, 400);

    return () => clearTimeout(searchTimeoutRef.current);
  }, [searchTerm]);

  // ----------------------------
  // DELETE / UNDO
  // ----------------------------
  const handleDelete = (id) => {
    const updated = allEmployeesData.map((e) =>
      e.id === id
        ? { ...e, wasActiveBeforeDelete: e.isActive, isActive: false, isDeleted: true }
        : e
    );
    setAllEmployeesData(updated);
    onEmployeesChange(updated);
  };

  const handleUndo = (id) => {
    const updated = allEmployeesData.map((e) =>
      e.id === id
        ? {
            ...e,
            isActive: e.wasActiveBeforeDelete ?? e.assessmentStatus === "Available",
            isDeleted: false,
            wasActiveBeforeDelete: undefined,
          }
        : e
    );
    setAllEmployeesData(updated);
    onEmployeesChange(updated);
  };

  // ----------------------------
  // FILTERS
  // ----------------------------
  const filteredEmployees = allEmployeesData.filter((emp) => {
    const normalizedSearch = (searchTerm || "").trim().toLowerCase();
    const visibleStatus = emp.assessmentStatus || emp.status || "Available";
    const statusAlias =
      visibleStatus === "Pending Assessment" ? "Pending Attempts" : "";

    const searchOk =
      !normalizedSearch ||
      [
        emp.employeeName,
        emp.departmentName,
        emp.status,
        emp.assessmentStatus,
        visibleStatus,
        statusAlias,
      ].some((value) =>
        String(value || "").toLowerCase().includes(normalizedSearch)
      );

    const deptOk =
      filters.departments.length === 0 ||
      filters.departments.includes(emp.departmentName);

    const statusOk =
      filters.status.length === 0 ||
      filters.status.includes(emp.status) ||
      filters.status.includes(emp.assessmentStatus);

    return searchOk && deptOk && statusOk;
  });

  // ----------------------------
  // CLIENT PAGINATION (CORRECT)
  // ----------------------------
  const totalPages = Math.ceil(filteredEmployees.length / rowsPerPage);

  const currentRows = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    return filteredEmployees.slice(start, start + rowsPerPage);
  }, [filteredEmployees, page, rowsPerPage]);

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
  };

  // ----------------------------
  // PAGE NUMBERS
  // ----------------------------
  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (page <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (page >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
      }
    }

    return pages;
  };

  return {
    handleAddDepartments,
    handleDelete,
    handleUndo,
    filteredEmployees,
    currentRows,
    totalPages,
    currentPage: page,
    handlePageChange,
    renderPageNumbers,
    isLoading,
  };
};
